import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}workflows`;

interface AllWorkflowResponse {
  id: string;
  shortName: string;
}

const getAllWorkflowQuery = async (): Promise<
  BackResponse<AllWorkflowResponse[]> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<AllWorkflowResponse[]>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getAllWorkflowQuery;
